import type { GiftCatalogItem } from "../../../types";

// Catalog artwork is a deliberate placeholder strategy (server.js's own
// comment on VIRTUAL_GIFT_CATALOG): imageUrl stays null until real art
// exists, so every card falls back to its emoji today - swapping in real
// images later needs no change here, just filling in that field server-side.
export function VirtualGiftCard({
  item,
  selected,
  balance,
  onSelect,
}: {
  item: GiftCatalogItem;
  selected: boolean;
  balance: number;
  onSelect: () => void;
}) {
  const affordable = balance >= item.price;

  return (
    <button
      type="button"
      className={`virtual-gift-card${selected ? " is-selected" : ""}${!affordable ? " is-unaffordable" : ""}`}
      onClick={onSelect}
      disabled={!affordable}
      aria-pressed={selected}
      aria-label={`${item.name}, ${item.price} credits${!affordable ? `, need ${item.price - balance} more credits` : ""}`}
    >
      <span className="virtual-gift-card-art">{item.imageUrl ? <img src={item.imageUrl} alt="" /> : <span aria-hidden="true">{item.emoji}</span>}</span>
      <span className="virtual-gift-card-name">{item.name}</span>
      <span className="virtual-gift-card-price">
        <i className="bi bi-gem" aria-hidden="true" /> {item.price}
      </span>
      {!affordable && <span className="virtual-gift-card-need">Need {item.price - balance} more</span>}
      {selected && (
        <span className="virtual-gift-card-check" aria-hidden="true">
          <i className="bi bi-check-lg" />
        </span>
      )}
    </button>
  );
}
